// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const CirclePositioner = require('client-v2/common/components/circle-positioner')
const EmbeddedPlayer = require('client-v2/common/components/embedded-player')
const LazyImage = require('client-v2/common/components/lazy-image')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoFooter = require('client-v2/into-landing/components/footer')
const IntoLinkModal = require('client-v2/into-landing/containers/link-modal/component-smart')

const bem = BemEntity('IntoContentProfileLayout')

function IntoContentProfileLayout(props) {
  const { provider: { faviconURL, id, streamTitle }, url, onClick } = props
  return (
    tag('div', {
      className: bem.block({
        video: !!props.embedUrl
      })
    },
      tag('div', {
        className: bem.element('container')
      },
        tag('div', {
          className: bem.element('content-wrapper')
        },
          tag(IntoCardContent, props)
        ),
        tag('div', {
          className: bem.element('details-wrapper')
        },
          tag('div', {
            className: bem.element('details')
          },
            props.likers.size !== 0 && tag('div', {
              className: bem.element('likers')
            },
              props.likers.slice(0, 7).map(liker => (
                tag(IntoLikerUserAvatar, {
                  liker,
                  onClick
                })
              ))
            ),
            tag('div', {
              className: bem.element('title')
            },
              props.title
            ),
            tag('div', {
              className: bem.element('provider')
            },
              tag('a', {
                className: bem.element('provider-info'),
                href: url,
                rel: 'external nofollow noopener',
                target: '_blank'
              },
                tag('div', {
                  className: bem.element('source')
                },
                  id
                ),
                tag('div', {
                  className: bem.element('stream')
                },
                  streamTitle
                )
              ),
              tag('a', {
                className: bem.element('provider-icon-wrapper'),
                href: url,
                rel: 'external nofollow noopener',
                target: '_blank'
              },
                tag(LazyImage, {
                  className: bem.element('provider-icon'),
                  rel: 'external nofollow noopener',
                  target: '_blank',
                  sources: [ faviconURL ]
                })
              )
            )
          )
        ),
        tag(IntoLinkModal)
      ),
      tag(IntoFooter, {
        className: bem.element('footer')
      })
    )
  )
}

module.exports = IntoContentProfileLayout

function IntoLikerUserAvatar(props) {
  const { liker, onClick } = props
    // Temporary workaround while we have multiple paths for profile navigation
  return (
    tag('a', {
      className: bem.element('liker'),
      href: `/${liker.username}`,
      onClick: onClick
    },
      tag(LazyImage, {
        className: bem.element('liker-image'),
        rel: 'external nofollow noopener',
        target: '_blank',
        sources: [ liker['photo_url'] ]
      }),
      tag(CirclePositioner, {
        className: bem.element('badge-positioner')
      },
        tag(Icon, {
          className: bem.element('badge'),
          id: 'heart'
        })
      )
    )
  )
}

function IntoCardContent(props) {
  const { isRedditVideo, embedUrl, thumbnail, url } = props
  if (!embedUrl) {
    if (isRedditVideo) {
      return tag('a', {
        className: bem.element('reddit-video'),
        href: url,
        rel: 'external nofollow noopener',
        target: '_blank'
      },
        tag('img', {
          className: bem.element('image'),
          src: thumbnail
        })
      )
    }
    return tag('img', {
      className: bem.element('image'),
      src: thumbnail
    })
  }
  return (
    tag('div', {
      className: bem.element('embed-wrapper')
    },
      tag(LazyImage, {
        className: bem.element('embed-image'),
        rel: 'external nofollow noopener',
        target: '_blank',
        sources: [ thumbnail ]
      }),
      tag(EmbeddedPlayer, {
        className: bem.element('embed-player'),
        src: embedUrl,
        fallbackUrl: url
      })
    )
  )
}
